import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-4 w-full" }
const _hoisted_2 = { class: "w-full flex justify-between gap-4 bg-white p-6 my-3 rounded-md shadow-md" }
const _hoisted_3 = { class: "font-extrabold w-[90%] text-neutral-900" }
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = ["initial", "enter"]
const _hoisted_6 = { class: "flex flex-col pb-5" }
const _hoisted_7 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageVoice = _resolveComponent("MessageVoice")!
  const _component_SelectButton = _resolveComponent("SelectButton")!
  const _directive_motion = _resolveDirective("motion")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.questionCount) + "." + _toDisplayString(" " + _ctx.question.prompt), 1),
      (_ctx.playAudio)
        ? (_openBlock(), _createBlock(_component_MessageVoice, {
            key: 0,
            msg: _ctx.msgVoice(_ctx.question.prompt),
            scaleIcons: 0.8,
            showIconsName: false,
            onOnEndMessage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSpeak($event)))
          }, null, 8, ["msg", "scaleIcons"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.question?.items, (item, i) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          key: i,
          initial: _ctx.initialMotion,
          enter: _ctx.enterMotion.getEnterMotion((i + 1) * 200),
          class: _normalizeClass(`bg-white flex items-center sm:pl-3 my-3 gap-2 rounded-md shadow-md w-full`)
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("label", {
              for: item.id,
              class: "cursor-pointer p-4 w-full"
            }, [
              _createElementVNode("p", null, [
                _createElementVNode("b", null, _toDisplayString(String.fromCharCode(i + 65)) + ".", 1),
                _createTextVNode(" " + _toDisplayString(item.answerText), 1)
              ])
            ], 8, _hoisted_7),
            _createVNode(_component_SelectButton, {
              modelValue: item.selected,
              "onUpdate:modelValue": [($event: any) => ((item.selected) = $event), ($event: any) => (_ctx.onAnswerSelect(item))],
              options: _ctx.options,
              optionLabel: "label",
              optionValue: "value",
              dataKey: "value",
              "aria-labelledby": "custom-question-tf",
              class: "custom-question-tf"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
          ])
        ], 8, _hoisted_5)), [
          [_directive_motion]
        ])
      }), 128))
    ])
  ]))
}